import { call, put, takeLatest } from 'redux-saga/effects';
import { EDI_FILTER_MARKET_DATA_REQUEST, EDI_FILTER_NPI_DATA_REQUEST, EDI_FILTER_STATE_DATA_REQUEST, EDI_FILTER_TIN_DATA_REQUEST, SMART_EDIT_STATUS_REQUEST, SMART_EDIT_TOP_CLAIM_REQUEST, SMART_EDIT_TOP_REASONS_REQUEST, SMART_EDITS_SUMMARY_REQUEST } from '@src/middleware/actions/actionTypes';
import { fetchEdiFilterMarketError, fetchEdiFilterMarketLoading, fetchEdiFilterMarketSuccess, fetchEdiFilterNpiError, fetchEdiFilterNpiLoading, fetchEdiFilterNpiSuccess, fetchEdiFilterStateError, fetchEdiFilterStateLoading, fetchEdiFilterStateSuccess, fetchEdiFilterTinError, fetchEdiFilterTinLoading, fetchEdiFilterTinSuccess } from '@src/middleware/actions/ServiceInteraction/DigitalSolutions/ediFilterActions';
import {
  getEdiFilterDataBulkRequest, getEdiFilterDataRequest,
  getEdiFilterDataBulkJobRequest

} from '@src/middleware/services/serviceInteraction/digitalSummary/ediFilter/ediFilter.service';

export function* getEdiFilterNpiData(action: any) {
  try {
    yield put(fetchEdiFilterNpiLoading(true));

    const { showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};
    let response: any;
    if (isHighVolumeTinFlow) {
      response = yield call(getEdiFilterDataBulkJobRequest, restPayload);
    } else {
      response = yield call(getEdiFilterDataBulkRequest, restPayload);
    }
    yield put(fetchEdiFilterNpiSuccess(response));
    yield put(fetchEdiFilterNpiLoading(false));
  } catch (error) {
    yield put(fetchEdiFilterNpiError(true));
    yield put(fetchEdiFilterNpiLoading(false));
  }
}

export function* getEdiFilterStateData(action: any) {
  try {
    yield put(fetchEdiFilterStateLoading(true));

    const response = yield call(
      getEdiFilterDataRequest,
      action?.payload
    );
    yield put(fetchEdiFilterStateSuccess(response));
    yield put(fetchEdiFilterStateLoading(false));
  } catch (error) {
    yield put(fetchEdiFilterStateError(true));
    yield put(fetchEdiFilterStateLoading(false));
  }
}

export function* getEdiFilterMarketData(action: any) {
  try {
    yield put(fetchEdiFilterMarketLoading(true));

    const response = yield call(
      getEdiFilterDataRequest,
      action?.payload,
      "market"
    );
    yield put(fetchEdiFilterMarketSuccess(response));
    yield put(fetchEdiFilterMarketLoading(false));
  } catch (error) {
    yield put(fetchEdiFilterMarketError(true));
    yield put(fetchEdiFilterMarketLoading(false));
  }
}

export function* getEdiFilterTinData(action: any) {
  try {
    yield put(fetchEdiFilterTinLoading(true));
    const { showGeoSegView, isHighVolumeTinFlow, ...restPayload } = action?.payload || {};
    let response: any;

    if (isHighVolumeTinFlow) {
      response = yield call(getEdiFilterDataBulkJobRequest, restPayload);
    } else {
      response = yield call(getEdiFilterDataBulkRequest, restPayload);
    }
    yield put(fetchEdiFilterTinSuccess(response));
    yield put(fetchEdiFilterTinLoading(false));
  } catch (error) {
    yield put(fetchEdiFilterTinError(true));
    yield put(fetchEdiFilterTinLoading(false));
  }
}

export function* ediFilterSaga() {
  yield takeLatest(
    EDI_FILTER_NPI_DATA_REQUEST,
    getEdiFilterNpiData
  );
  yield takeLatest(
    EDI_FILTER_STATE_DATA_REQUEST,
    getEdiFilterStateData
  );
  yield takeLatest(
    EDI_FILTER_MARKET_DATA_REQUEST,
    getEdiFilterMarketData
  );
  yield takeLatest(
    EDI_FILTER_TIN_DATA_REQUEST,
    getEdiFilterTinData
  );
}
